export function getBiId(biId = '', name = ''): string | undefined {
	if (biId) {
		const basePart = `${biId}-radio-group`;
		const namePart = name ? `-${name}` : '';

		return `${basePart}${namePart}`;
	}
}
